<template>
    <v-dialog persistent v-model="addEstimationDialog" @keydown.esc="addEstimationDialog = false" max-width="600px">
        <template v-slot:activator="{ on, addEstimationAttrs }">
            <v-btn v-if="!mode || mode != 'string'" :color="groupSetting.mainColor" style="float:right" small rounded dark v-bind="addEstimationAttrs" v-on="on">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <span v-if="mode == 'string'" v-bind="addEstimationAttrs" v-on="on" class="finger caption font-weight-bold mr-2">{{ displayString }}</span>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">간편 견적 작성</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mb-n5">
                        <v-col cols="6">
                            <v-menu
                                    v-model="estimationDateDialog"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                            v-model="selectedOptions.estimationDate"
                                            label="작성일"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="selectedOptions.estimationDate" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n11">
                        <v-col cols="10" xs="12">
                            <v-autocomplete
                                    v-model="selectedOptions.clientId"
                                    :loading="addEstimationClientLoading"
                                    :items="clientList"
                                    :search-input.sync="clientSearch"
                                    no-data-text="일치하는 거래처가 없습니다."
                                    auto-select-first
                                    clear-icon="mdi-format-clear"
                                    flat
                                    label="거래처를 검색해주세요. (옵션)"
                                    solo-inverted
                                    dense
                                    clearable
                                    ref="clientSearchTextField"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" xs="12">
                            <AddClientButton></AddClientButton>
                        </v-col>
<!--                        <v-col cols="6" xs="12">-->
<!--                            <v-text-field label="연락처" hint="거래처 검색 시 자동 입력됩니다." v-model="clientPhone" readonly></v-text-field>-->
<!--                        </v-col>-->
                    </v-row>
                    <v-row class="mb-n9">
                        <!-- <v-col cols="4">
                            <v-select
                                    :items="productCategory"
                                    label="종류 *"
                                    item-value="text"
                                    v-model="selectedOptions.category"
                                    required
                            ></v-select>
                        </v-col> -->
                        <v-col cols="12">
                            <v-text-field label="제목 *" hint="작업명을 입력하세요." v-model="selectedOptions.title" required></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col cols="4" class="">
                            <v-text-field label="제품수량 *" hint="제품의 수량을 입력하세요" v-model="selectedOptions.quantities" @change="calculate"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="">
                            <v-text-field label="생산절수 *" hint="생산 시 절수를 입력하세요" v-model="selectedOptions.cuttings" @change="calculate"></v-text-field>
                        </v-col>
                        <v-col cols="4" class="">
                            <v-text-field label="생산판수 *" hint="생산 시 판수를 입력하세요" v-model="selectedOptions.plates" @change="calculate"></v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row class="mb-n9">
                        <v-col cols="4" class="">
                            <v-text-field label="필요전지수량 (자동계산)" hint="필요전지 국전지의 수량입니다." v-model="selectedOptions.necessaryA0" disabled></v-text-field>
                        </v-col>
                        <v-col cols="4" class="">
                            <v-text-field label="연당 수량 (자동계산)" hint="생산 시 절수를 입력하세요" v-model="selectedOptions.countsByR" disabled></v-text-field>
                        </v-col>
                        <v-col cols="4" class="">
                            <v-text-field label="인쇄 통수 (자동계산)" hint="생산 시 판수를 입력하세요" v-model="selectedOptions.countsOfTong" disabled></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mb-n9">
                        <v-container fluid>
                            <v-radio-group row label="용지사이즈"
                            v-model="selectedOptions.paperSize"
                            @change="getCodeData">
                                <v-radio
                                    label="하드롱"
                                    color="info"
                                    value="ps1"
                                    
                                ></v-radio>
                                <v-radio
                                    label="4 X 6"
                                    color="info"
                                    value="ps2"
                                ></v-radio>
                                <v-radio
                                    label="국전"
                                    color="info"
                                    value="ps3"
                                ></v-radio>
                            </v-radio-group>
                        </v-container>
                    </v-row>

                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="paper1List"
                                    label="지류1"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.paper"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="지류 예상금액" v-model="selectedOptions.paperPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="paper2List"
                                    label="지류2"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.paper"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="지류 예상금액" v-model="selectedOptions.paperPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="plateList"
                                    label="판비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.plate"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="판비 예상금액" v-model="selectedOptions.platePrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="printingList"
                                    label="인쇄비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.printing"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="인쇄비 예상금액" v-model="selectedOptions.printingPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="coatingList"
                                    label="코팅비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.coating"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="코팅비 예상금액" v-model="selectedOptions.coatingPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="thompsonList"
                                    label="톰슨비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.thompson"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="톰슨비 예상금액" v-model="selectedOptions.thompsonPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="bondingList"
                                    label="접착비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.bonding"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="접착비 예상금액" v-model="selectedOptions.bondingPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="subsidiaryList"
                                    label="부자재"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.subsidiary"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="부자재 예상금액" v-model="selectedOptions.subsidiaryPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n9">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="processingList"
                                    label="임가공비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.processing"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="임가공비 예상금액" v-model="selectedOptions.processingPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-n7">
                        <v-col :cols="detailedPrice != true ? 12 : 8">
                            <v-select
                                    :items="deliveryList"
                                    label="운반비"
                                    item-text="name"
                                    item-value="id"
                                    v-model="selectedOptions.delivery"
                                    required
                                    @change="calculate"
                            ></v-select>
                        </v-col>
                        <v-col v-if="detailedPrice == true" cols="4">
                            <v-text-field label="운반비 예상금액" v-model="selectedOptions.deliveryPrice" readonly></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="mb-n2 text-center text-h6">
                        <v-col cols="12">
                            {{ finalPriceSummary }}
                        </v-col>
                    </v-row>

                    <v-row class="">
                        <v-col cols="6">
                            <v-text-field label="최종 개당가격 (입력)" v-model="selectedOptions.finalUnitPrice" @change="calculate"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field label="총액 (자동계산)" v-model="selectedOptions.finalTotalPrice" disabled></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="px-3 mb-n7">
                        <v-textarea
                                outlined
                                name="input-7-4"
                                label="비 고"
                                v-model="selectedOptions.comment"
                        ></v-textarea>
                    </v-row>
                </v-container>
                <small>* 항목은 필수입니다.</small>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="userRole == 'superuser'"
                    class="ml-5"
                    x-small
                    color="secondary"
                    dark
                    @click="toggleDetailedPrice"
                >
                    {{ detailedPriceText }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="save">저장</v-btn>
                <v-btn color="blue darken-1" text @click="addEstimationDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import number_format from "@/utilities/formatting/number_format"
import AddClientButton from "@/components/admin/button/AddClientButton";

export default {
    name: 'AddEstimationDialog',
    components: {
        AddClientButton
    },
    props: {
        estimationId: null,
        mode: null,
        displayString: null,
    },
    data() {
        return {
            "options": [],
            "paper1List": [],
            "paper2List": [],
            "plateList": [],
            "printingList": [],
            "coatingList": [],
            "thompsonList": [],
            "bondingList": [],
            "subsidiaryList": [],
            "processingList": [],
            "deliveryList": [],
            selectedOptions: {
                "id": null,
                "estimationDate": new Date().toISOString().substr(0, 10),
                "clientId": null,
                "title": null,
                "comment": null,
                "quantities": null,
                "cuttings": null,
                "plates": null,
                "necessaryA0": null,
                "countsByR": null,
                "countsOfTong": null,
                "paperSize": 'ps1',
                "paper": null,
                "paperPrice": 0,
                "plate": null,
                "platePrice": 0,
                "printing": null,
                "printingPrice": 0,
                "coating": null,
                "coatingPrice": 0,
                "thompson": null,
                "thompsonPrice": 0,
                "bonding": null,
                "bondingPrice": 0,
                "subsidiary": null,
                "subsidiaryPrice": 0,
                "processing": null,
                "processingPrice": 0,
                "delivery": null,
                "deliveryPrice": 0,
                "unitPrice": 0,
                "finalUnitPrice": 0,
                "finalTotalPrice": 0,
            },
            addEstimationClientLoading: false,
            addEstimationDialog: false,
            estimationDateDialog: false,
            dueDateDialog: false,
            clientList: [],
            clientSearch: null,
            orderMethodList: this.$store.getters.getOrderMethodList,
            productCategory: this.$store.getters.getProductCategoryList,
            groupSetting: null,
            userRole: null,
            detailedPrice: false,
            detailedPriceText: "세부가격보기",
        }
    },
    computed: {
        finalPriceSummary() {
            const selectedOptions = this.selectedOptions
            return number_format(selectedOptions && selectedOptions.unitPrice ? selectedOptions.unitPrice : 0) + '원 X ' + number_format(selectedOptions && selectedOptions.quantities ? selectedOptions.quantities : 0) + '매 = ' + number_format(selectedOptions && selectedOptions.unitPrice && selectedOptions.quantities ? selectedOptions.unitPrice * selectedOptions.quantities : 0) + '원'
        },
    },
    watch: {
        clientSearch (val) {
            val && val !== this.selectedOptions.clientId && this.querySelections(val)
        },
        async addEstimationDialog(flag) {
            if(flag == true && this.mode == 'string'){

                if(this.estimationId > 0){

                    return axios({
                        method: 'GET',
                        headers: {
                            'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                        },
                        url: this.$store.getters.getApiUrl + '/api/v1/estimation/getEstimation/' + this.estimationId,
                        timeout: this.$store.getters.getApiRequestTimeLimit
                    })
                    .then(async response => {

                        const res = response.data.data

                        await this.getCodeData()

                        let clientBlock = res.clientName

                        if(res.clientBrand){
                            clientBlock += '(' + res.clientBrand + ')'
                        }

                        if(res.clientPhone){
                            clientBlock += ' ' + res.clientPhone
                        }

                        this.clientList = [{ text: clientBlock, value: res.clientId }]

                        res.estimationDate = this.$day(res.estimationDate).format('YYYY-MM-DD')
                        this.selectedOptions = res

                        this.checkData()

                    })

                }else{

                    alert('견적 고유번호가 없습니다.\n개발자에게 문의하세요.')
                    return false

                }

            }else{
                await this.getCodeData()
            }
        },
    },
    methods: {
        checkData() {
            const res = this.selectedOptions

            //지류 체크
            let paperCheck = false
            this.paper1List.forEach(function(v){
                if(v.id == res.paper){
                    paperCheck = true
                }
            })

            this.paper2List.forEach(function(v){
                if(v.id == res.paper){
                    paperCheck = true
                }
            })

            if(!paperCheck){
                res.paper = 0
                this.paper1List.unshift({id: 0, name: '[삭제됨] ' + res.paperName})
            }

            //판비 체크
            let plateCheck = false
            this.plateList.forEach(function(v){
                if(v.id == res.plate){
                    plateCheck = true
                }
            })

            if(!plateCheck){
                res.plate = 0
                this.plateList.unshift({id: 0, name: '[삭제됨] ' + res.plateName})
            }

            //인쇄 체크
            let printingCheck = false
            this.printingList.forEach(function(v){
                if(v.id == res.printing){
                    printingCheck = true
                }
            })

            if(!printingCheck){
                res.printing = 0
                this.printingList.unshift({id: 0, name: '[삭제됨] ' + res.printingName})
            }

            //코팅 체크
            let coatingCheck = false
            this.coatingList.forEach(function(v){
                if(v.id == res.coating){
                    coatingCheck = true
                }
            })

            if(!coatingCheck){
                res.coating = 0
                this.coatingList.unshift({id: 0, name: '[삭제됨] ' + res.coatingName})
            }

            //톰슨 체크
            let thompsonCheck = false
            this.thompsonList.forEach(function(v){
                if(v.id == res.thompson){
                    thompsonCheck = true
                }
            })

            if(!thompsonCheck){
                res.thompson = 0
                this.thompsonList.unshift({id: 0, name: '[삭제됨] ' + res.thompsonName})
            }

            //접착비 체크
            let bondingCheck = false
            this.bondingList.forEach(function(v){
                if(v.id == res.bonding){
                    bondingCheck = true
                }
            })

            if(!bondingCheck){
                res.bonding = 0
                this.bondingList.unshift({id: 0, name: '[삭제됨] ' + res.bondingName})
            }

            //부자재 체크
            let subsidiaryCheck = false
            this.subsidiaryList.forEach(function(v){
                if(v.id == res.subsidiary){
                    subsidiaryCheck = true
                }
            })

            if(!subsidiaryCheck){
                res.subsidiary = 0
                this.subsidiaryList.unshift({id: 0, name: '[삭제됨] ' + res.subsidiaryName})
            }

            //임가공비 체크
            let processingCheck = false
            this.processingList.forEach(function(v){
                if(v.id == res.processing){
                    processingCheck = true
                }
            })

            if(!processingCheck){
                res.processing = 0
                this.processingList.unshift({id: 0, name: '[삭제됨] ' + res.processingName})
            }

            //운반비 체크
            let deliveryCheck = false
            this.deliveryList.forEach(function(v){
                if(v.id == res.delivery){
                    deliveryCheck = true
                }
            })

            if(!deliveryCheck){
                res.delivery = 0
                this.deliveryList.unshift({id: 0, name: '[삭제됨] ' + res.deliveryName})
            }
        },
        async getCodeData() {

            return axios({
                method: 'GET',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/setting/commonData/getCodeList?category=' + this.selectedOptions.paperSize || "ps1",
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                const res = response.data.data

                if(response.data && response.data.status != '9999') {

                    this.paper1List = res.paper1
                    this.paper2List = res.paper2
                    this.plateList = res.plate
                    this.printingList = res.printing
                    this.coatingList = res.coating
                    this.thompsonList = res.thompson
                    this.bondingList = res.bonding
                    this.subsidiaryList = res.subsidiary
                    this.processingList = res.processing
                    this.deliveryList = res.delivery

                }

            })

        },
        checkDeletedOptions() {
            if(this.selectedOptions.paper == 0){
                alert("지류 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.plate == 0){
                alert("판비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.printing == 0){
                alert("인쇄비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.coating == 0){
                alert("코팅비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.thompson == 0){
                alert("톱슨비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.bonding == 0){
                alert("접착비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.subsidiary == 0){
                alert("부자재 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.processing == 0){
                alert("임가공비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }

            if(this.selectedOptions.delivery == 0){
                alert("운반비 옵션이 삭제되어서 계산이 불가합니다.\n존재하는 옵션을 선택해주세요.")
                return false
            }
        },
        async calculate() {

            if(!this.selectedOptions.quantities || !this.selectedOptions.cuttings || !this.selectedOptions.plates){
                return false
            }

            if(this.selectedOptions.id > 0 && !this.checkDeletedOptions()){
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                data: this.selectedOptions,
                url: this.$store.getters.getApiUrl + '/api/v1/estimation/calculate',
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.status != '9999') {
                    
                    let tmpData = response.data.data
                    //calculate 시 넘어오는 값은 id를 포함하고 있지 않아서 덮어씌워버리므로 새 데이터가 입력되는 것 방지용...
                    if(this.selectedOptions.id > 0){
                        tmpData.id = this.selectedOptions.id
                    }
                    this.selectedOptions = tmpData

                }else{

                    this.selectedOptions = []

                }

            })
        },
        async save() {

            if(this.selectedOptions.finalTotalPrice == 0){
                return false
            }

            if(!this.selectedOptions.title){
                alert('제목을 입력해주세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                data: this.selectedOptions,
                url: this.$store.getters.getApiUrl + '/api/v1/estimation/save',
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(!this.selectedOptions.id && response.data && response.data.id > 0){
                    this.selectedOptions.id = response.data.id
                }

                alert(response.data.message)
                location.reload()
                return false

            })
        },
        querySelections (v) {

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/client/search',
                data: {
                    clientType: 'general',
                    searchString: v
                },
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data != null && response.data.length > 0){

                    this.clientList = []

                    if(response.data && response.data[0].value > 0){
                        this.clientList = response.data
                    }

                }

            })
            .catch(() => {})

        },
        toggleDetailedPrice() {
            if(this.detailedPrice == false){
                this.detailedPrice = true
                this.detailedPriceText = "세부가격보기"
            }else{
                this.detailedPrice = false
                this.detailedPriceText = "세부가격닫기"
            }
        }
    },
    mounted: async function() {
        if(this.paper1List.length == 0){
            await this.getCodeData()
        }
    },
    created: async function() {
        if(this.$store.getters.getAccessToken != null){
            this.groupSetting = this.$store.getters.getGroupSetting
        }
        
        if(this.userRole == null){
            this.userRole = this.$store.getters.getUserRole
        }
    },
}
</script>

<style scoped>
    .finger { cursor: pointer; }
</style>